import * as types from '@/store/types';
import service from '@/api/LandMovementService'
import store from '@/store'

export default {
    [types.ACTION_ADD_NOTIFICATION]: ({commit}, payload) => {
    	service.addNotification(payload)
                .then( (response) => {
                       if (response) {
                           store.commit(types.MUTATE_NOTIFICATION_ID, reponse.notification_id)
                           store.commit(types.MUTATE_MODIFIED, false)
                       }
                   })
    },
    [types.ACTION_UPDATE_NOTIFICATION]: ({commit}, payload) => {
        service.updateNotification(payload)
    },
    [types.ACTION_ADD_WAYPOINTS]: ({commit}, payload) => {
        service.addWaypoints(payload)
    },
    [types.ACTION_ADD_NOTIFICATION]: ({commit}, payload) => {
        service.addNotification(payload)
    },
    [types.ACTION_ADD_CONVOYS]: ({commit}, payload) => {
        service.addConvoys(payload)
    },
    [types.ACTION_ADD_PARTICIPANTS]: ({commit}, payload) => {
        service.addParticipants(payload)
    },
    [types.ACTION_ADD_VEHICLES]: ({commit}, payload) => {
        service.addVehicles(payload)
    },
    [types.ACTION_ADD_TRUCKS]: ({commit}, payload) => {
        service.addNotification(payload)
    },
    [types.ACTION_ADD_PHOTOS]: ({commit}, payload) => {
        service.addPhotos(payload)
    },
    [types.ACTION_FIND_PHOTOS]: ({commit}, payload) => {
        service.getPhotos(payload)
    }        

}


// WEBPACK FOOTER //
// ./src/store/modules/land_movement/actions.js